<div class="js-hide-on-fullscreen row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Karte"}}</h4>
	</div>
</div>
<div class="filter-wrapper"></div>
<div class="map-toolbar"></div>
<div class="row js-help-layer map-layer-1">
	<div class="col-sm-12">
		<div class="card-box clearfix">
			<div id="map" style="width: 100%; height: 400px;"></div>
		</div>
	</div>
</div>
<div class="row">
	<div id="extension" class="col-xs-12"></div>
</row>

